import EditTransaction from '@/transaction/edit-transaction/EditTransaction.vue'
import {registerRoute} from '@/router'

export const EDIT_TRANSACTION = {
    componentName: 'EditTransaction',
    component: EditTransaction,
    meta: {requiresOrg: true}
}

registerRoute(EDIT_TRANSACTION)